module.exports = __webpack_public_path__ + "img/simOpen100.b6e7375f.png";